<template>
  <authentication-layout>
    <header slot="form-header" class="header">
      <h2 class="title">Entre com sua conta</h2>
    </header>

    <template slot="form-content">
      <v-card class="elevation-0 card">
        <v-alert outline color="error" icon="mdi-alert" :value="formSigninFailed">
          {{formSigninFailedMessage}}
        </v-alert>

        <!--<v-form>-->
          <!--<v-card-text>-->
            <!--<v-text-field-->
              <!--v-model="username"-->
              <!--name="username"-->
              <!--label="Usuário"-->
              <!--type="text"-->
              <!--@keypress.enter="signin(username, password)"-->
              <!--:disabled="formSigninDisable"-->
            <!--/>-->

            <!--<v-text-field-->
              <!--v-model="password"-->
              <!--name="password"-->
              <!--label="Senha"-->
              <!--hint="Mínimo de 8 caracteres"-->
              <!--min="8"-->
              <!--@click:append="() => (hidePassword = !hidePassword)"-->
              <!--@keypress.enter="signin(username, password)"-->
              <!--:append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"-->
              <!--:type="hidePassword ? 'password' : 'text'"-->
              <!--:disabled="formSigninDisable"-->
            <!--/>-->
          <!--</v-card-text>-->

          <!--<v-card-actions class="action">-->
            <!--<v-btn-->
              <!--class="mr-3"-->
              <!--flat-->
              <!--small-->
              <!--route-->
              <!--:disabled="formSigninDisable"-->
              <!--:to="'/autenticacao/senha/recuperar'"-->
            <!--&gt;-->
              <!--<v-icon left>mdi-lock-outline mdi-18px</v-icon>-->
              <!--<span class="text">Esqueci minha senha</span>-->
            <!--</v-btn>-->

            <!--<v-spacer/>-->

            <!--<v-btn-->
              <!--large-->
              <!--color="accent"-->
              <!--:disabled="formSigninDisable"-->
              <!--:loading="formSigninDisable"-->
              <!--@click="signin(username, password)"-->
            <!--&gt;-->
              <!--Entrar-->
              <!--<v-icon right>mdi-arrow-right</v-icon>-->
            <!--</v-btn>-->

          <!--</v-card-actions>-->
        <!--</v-form>-->

        <v-container>
          <v-layout justify-center>
            <v-btn
              class="mr-3"
              @click="oauth2()"
            >
              <v-icon left>mdi-lock-outline mdi-18px</v-icon>
              <span class="text">Entrar com SignGo</span>
            </v-btn>
          </v-layout>
        </v-container>

      </v-card>
    </template>
  </authentication-layout>
</template>

<script>
  import axios from 'axios';
  import AuthenticationLayout from '@/layouts/AuthenticationLayout';
  import AuthenticationService from '@/services/AuthenticationService';
  import { clientId, redirectUri } from '@/constants/API_SIGN_GO';

  export default {
    name: 'FormSignin',
    components: {
      AuthenticationLayout,
    },
    data() {
      return {
        username: '',
        password: '',
        hidePassword: true,
        formSigninDisable: false,
        formSigninFailed: false,
        formSigninFailedMessage: '',
      };
    },
    methods: {
      signin(username, password) {
        this.formSigninFailed = false;
        this.formSigninDisable = true;

        AuthenticationService.signin(username, password)
          .then((response) => {
            const token = response.data.access_token;
            this.formSigninDisable = false;
            localStorage.setItem('access_token', token);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            this.getUser()
              .then(() => this.$router.push('/'));
          })
          .catch((error) => {
            this.formSigninDisable = false;
            this.formSigninFailed = true;
            this.formSigninFailedMessage = error.response.data.error_description;
          });
      },
      oauth2() {
        const link = `${process.env.SIGNGO}/#/autenticacao/oauth/authorize?response_type=token&client_id=${clientId()}&redirect_uri=${redirectUri()}`;
        const popup = window.open(link, 'auth', 'width=420,height=640');
        const closeEvent = setInterval(() => {
          if (popup.closed) {
            clearInterval(closeEvent);
            axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
            this.getUser()
              .then(() => this.$router.push('/'));
          }
        }, 500);
      },
      getUser() {
        return this.$store.dispatch('getUser');
      },
    },
  };
</script>

<style scoped lang="scss">
  .header {
    > .title {
      text-align: center;
      margin-bottom: 2rem;
    }
  }

  .card {
    width: 100%;
    max-width: 420px;
  }
</style>



// WEBPACK FOOTER //
// src/views/authentication/signin/FormSignin.vue